import React, { Component } from 'react'
import ModalBody from "../modalbody";
import { connect } from 'react-redux';
import {getRateCard, getRateCardClear} from "../../actions"
import TimeComp from '../timepicker';
import moment from "moment"
import ButtonLoader from '../btnloader';
import Getmaster from '../getmaster';

const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

class RateCardModal extends Component {

    state = {
        time: moment().get("hour") + ":" + moment().get("minute"),
        day: days[moment().day()]
    }

    componentDidMount(){
        this.getRate();
    }

    getRate = () => {
        let {time, day} = this.state;
        this.props.getRateCard({time, day});
    }

    onTimeChange = ({hour, minute}) => {
        this.setState({
            time: hour + ":" + minute
        })
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.time !== this.state.time || prevState.day !== this.state.day){
            this.getRate();
        }
    }

    render() {
        let {fetching, data} = this.props.rateCard;
        return (
            <ModalBody heading="">
                <div style={{minHeight: `560px`}}>
                    <div className="flex-center">
                        <h3 className="f-600 header-underline text-center">Rate Card</h3>
                    </div>
                    <div className="row m-t-20">
                        <div className="col-md-6">
                            <select value={this.state.day} className="form-control input-md" onChange={(e) => this.setState({day: e.target.value})}>
                                <option value="monday">Monday</option>
                                <option value="tuesday">Tuesday</option>
                                <option value="wednesday">Wednesday</option>
                                <option value="thursday">Thursday</option>
                                <option value="friday">Friday</option>
                                <option value="saturday">Saturday</option>
                                <option value="sunday">Sunday</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <TimeComp time={this.state.time} onTimeChange={this.onTimeChange} />
                        </div>
                    </div>
                    <div className="container">
                        <div className="m-t-10 flex-center flex-column" style={{minHeight: `180px`}}>
                            {fetching ? <ButtonLoader /> : data ?
                            <table className="table table-bordered table-condensed table-responsive table-striped f-18">
                                <tbody>
                                    <tr>
                                        <td>Base Fare for {data.minimum_km} km</td>
                                        <td>&#8377; {data.base_fare}</td>
                                    </tr>
                                    <tr>
                                        <td>Extra Km Cost after {data.minimum_km} km</td>
                                        <td>&#8377; {data.extra_km_cost} per km</td>
                                    </tr>
                                    <tr>
                                        <td>Additional Cost</td>
                                        <td>&#8377; {data.additional_km_cost}</td> 
                                    </tr>
                                </tbody>
                            </table> : null}
                            <p><b>Note</b>: Rates are exclusive of GST & SGST</p>
                        </div>
                        <div className="flex-center">
                            <h4>Terms & Conditions</h4>
                        </div>
                        <Getmaster id={7} />
                    </div>
                </div>
            </ModalBody>
        )
    }

    componentWillUnmount(){
        this.props.getRateCardClear();
    }

}

const mapStateToProps = ({rateCard}) => ({
    rateCard
})

const mapDispatchToProps = {
    getRateCard, getRateCardClear
}

export default connect(mapStateToProps, mapDispatchToProps)(RateCardModal)